import * as _ from 'lodash'

import {ITree, ITreeNode, ITreeNodeProvider} from "./PA.UIM.Core.IF.Search";
import {ASync} from "../PA.Core/Basic/ASync";



export class ColumnNodeProvider implements ITreeNodeProvider {

  fieldIds: string[]
  defaultValues: string[]
  delimiter: string
  ruggedTree: boolean = false

  constructor(sFieldIds: string[], options: {defaultValues?: string | string[], levelDelimiter?: string, ruggedTree?: boolean}) {
    let opts = options || {}

    this.fieldIds = sFieldIds
    this.defaultValues = _.map(sFieldIds, (aFieldId, idx) => {
      if(_.isEmpty(opts.defaultValues)){ return 'NA'}
      if(_.isString(opts.defaultValues)){ return opts.defaultValues}
      if(_.isArray(opts.defaultValues) && (opts.defaultValues.length > idx)){
        return opts.defaultValues[idx] || 'NA'
      }
      return 'NA'
    })
    this.delimiter =opts.levelDelimiter || '|'
    this.ruggedTree = !!opts.ruggedTree

  }

  getAllParents(wb_id: number | string, dataRow: any): Promise<ITreeNode[]> {
    const self = this
    return new Promise<ITreeNode[]>((resolve, error) => {

      let returnValue: ITreeNode[] = []

      _.forEach(self.fieldIds, (aFieldId: string, idx: number) => {
        let fieldData = dataRow[aFieldId] || ''
        let defaults = self.defaultValues[idx]
        let fieldDataSplit = fieldData.split(self.delimiter)
        let defaultsSplit = defaults.split(self.delimiter)

        if(self.ruggedTree) {
          _.forEach(fieldDataSplit, (rgdfieldDataValue: string, idxDataValue: number) => {
            let dfltValue = defaultsSplit[idxDataValue]
            if (_.isEmpty(rgdfieldDataValue)) {
              rgdfieldDataValue = dfltValue || defaultsSplit[0]
            }
            returnValue.push({id: rgdfieldDataValue, name: rgdfieldDataValue})
          })
        } else {
          // use the default values to defined the level
          _.forEach(defaultsSplit, (aDfltValue: string, idxSplit: number) => {
            let fieldDataValue = fieldDataSplit[idxSplit]
            if (_.isEmpty(fieldDataValue)) {
              fieldDataValue = aDfltValue
            }
            returnValue.push({id: fieldDataValue, name: fieldDataValue})
          })
        }

      })

      resolve(returnValue)
    })
  }

  getChildren(wb_id: number | string, dataRow: any): Promise<ITreeNode[]> {
    return ASync.resolve([]);
  }


}